var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "assistant-bubble" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open"
              }
            ],
            staticClass: "assistant-bubble__panel",
            attrs: { role: "dialog", "aria-label": "Lasso Assistant" }
          },
          [
            _c("header", { staticClass: "assistant-bubble__header" }, [
              _c("span", [_vm._v("Ask Lasso")]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "assistant-bubble__controls" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "assistant-bubble__minimise",
                      attrs: {
                        "aria-label": "Minimise the assistant",
                        title: "Minimise"
                      },
                      on: {
                        click: function($event) {
                          _vm.open = false
                        }
                      }
                    },
                    [_vm._v("\n          −\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "assistant-bubble__maximise",
                      attrs: {
                        to: { name: "assistant" },
                        "aria-label": "Open the full Lasso Assistant page",
                        title: "Open full screen"
                      }
                    },
                    [
                      _c("b-icon", {
                        attrs: {
                          icon: "arrow-expand",
                          "custom-size": "mdi-18px"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.everOpened
              ? _c("AssistantChat", { attrs: { active: _vm.everOpened } })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "assistant-bubble__launcher",
            attrs: {
              "aria-expanded": _vm.open ? "true" : "false",
              "aria-label": "Open the Lasso assistant"
            },
            on: { click: _vm.toggle }
          },
          [
            !_vm.everOpened
              ? _c("span", {
                  staticClass: "assistant-bubble__spark",
                  attrs: { "aria-hidden": "true" }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "assistant-bubble__launcher-label" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.open ? "Hide" : "Ask Lasso") + "\n    "
              )
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }